export const mixpanelToken = (() => {
  if (window.location.hostname.endsWith("3d.woolit.no")) {
    return "bead7c9c4858bc2d33624f4782c28f28";
  } else {
    return "06e05deb0ba9e58ce773a43b8694f10d";
  }
})();
